import { ClipLoader } from "react-spinners";

export const Spinner = () => {
  return <ClipLoader size={20} color="white" />
}